import React from 'react';

export const SendIcon = ({ width = 25, height = 24, color = "black", className, ...props }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
            {...props}
        >
            <path
                className={className}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.2715 7.33675L6.67946 11.8898L10.8745 14.3178L14.5735 10.6178C14.7611 10.4302 15.0155 10.325 15.2808 10.325C15.5461 10.3251 15.8005 10.4306 15.988 10.6183C16.1755 10.8059 16.2808 11.0603 16.2807 11.3256C16.2806 11.5909 16.1751 11.8452 15.9875 12.0328L12.2875 15.7328L14.7175 19.9268L19.2715 7.33675ZM19.5945 5.09275C20.7895 4.65975 21.9475 5.81775 21.5145 7.01275L16.2325 21.6178C15.7985 22.8158 14.1625 22.9618 13.5235 21.8587L10.3065 16.3008L4.74846 13.0838C3.64546 12.4448 3.79146 10.8088 4.98946 10.3748L19.5945 5.09275Z"
                fill={color}
            />
        </svg>
    );
};